import { useState } from 'react';

import { EmailDocumentsItem } from '../EmailDocumentsItem';

import { emailFieldNames } from '../../../../../lib/mocks/email-mock';

export const EmailDocumentsList = ({ formProps = {}, onFileChange = null }) => {
  const [files, setFiles] = useState([]);

  const handleChange = async event => {
    const filesArray = Array.from(event.target.files);
    let updatedFiles = [];

    setFiles(prevFiles => {
      const existingFileNames = new Set(prevFiles.map(file => file.name));
      const newFiles = filesArray.filter(file => !existingFileNames.has(file.name));
      updatedFiles = [...prevFiles, ...newFiles];
      return updatedFiles;
    });

    if (formProps?.setFieldValue) {
      await formProps.setFieldValue(emailFieldNames.attachments, updatedFiles);
    }
  };

  // expose handleChange to parent via ref so Upload button can live in the buttons row
  if (onFileChange) {
    onFileChange.current = handleChange;
  }

  const handleDelete = async file => {
    let updatedFiles = [];

    setFiles(prevFiles => {
      updatedFiles = prevFiles.filter(prevFile => prevFile.name !== file.name);
      return updatedFiles;
    });

    if (formProps?.setFieldValue) {
      await formProps.setFieldValue(emailFieldNames.attachments, updatedFiles);
    }
  };

  return (
    <div className="flex flex-col items-start gap-3">
      <span className="text-ml text-blackColor font-medium">Attachments</span>

      {files.map((item, fileIndex) => (
        <EmailDocumentsItem
          key={`${item.name}${fileIndex}`}
          item={item}
          handleDelete={() => handleDelete(item)}
        />
      ))}
    </div>
  );
};
